export default __webpack_public_path__ + "static/media/logo_siqeira.48341665.webp";